import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const FaqViewClientModule = lazy(loadModule);

export default FaqViewClientModule;
